import React, { useEffect, useRef, useState } from 'react'
import { Accordion, Col, Row } from 'react-bootstrap'
import CustomSelect from '../../Utilities/CustomSelect'
import { CoursesManangementVM } from '../../../Structure/ViewModels/Admin/CoursesManagementVM'
import { InstitutionsListVM } from '../../../Structure/ViewModels/Admin/InstitutionsList'
import ItemTab from './ItemTab'

const InstitutionsList = (props:{vm:CoursesManangementVM}) => {
    const [parent , setParent] = useState<{viewModel:CoursesManangementVM}>({viewModel:props.vm})
    const [vm , setVm] = useState<{viewModel:InstitutionsListVM}>({viewModel: new InstitutionsListVM()})
    const control = vm.viewModel

    useEffect(()=>{
        parent.viewModel.subscribeUpdate(setParent)
        control.subscribeUpdate(setVm)
        control.load()
    },[])
    useEffect(()=>{ 
        control.load() 
    },[control.Refresh])
    
    const addingButton = useRef<HTMLDivElement>(null)

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>)=>{
        if(event.key === 'Enter' && addingButton.current){
            addingButton.current.click()
        }
    }

    return (
        <Accordion defaultActiveKey={'0'} className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
            <Accordion.Item eventKey='0' className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}} >
                <Accordion.Button  className='border-0 border-bottom' style={{outline:'none', border:'none' , borderRadius:'0px', boxShadow:'none'}}>
                    <h5 className='ps-3 px-2'>جهات الاعتماد</h5>
                </Accordion.Button>
                <Accordion.Body  className=' d-flex flex-column justify-content-between overflow-y-auto'   style={{height:'400px'}}>
                {
                    control.Show(
                    <Row className='h-100'>
                        <Col xl={4} className=' p-1 pt-4 px-md-3 d-flex flex-column justify-content-between'   style={{maxHeight:'340px'}}>
                            <div className=' overflow-y-scroll'>
                            {
                                control.Data?.data.map((item , index)=>(
                                    <ItemTab key={index} id={item.id} value={item.name} dataType='الجهة' index={index} selected={control.SelectedInstitution === item.id} onSelect={a=>{control.SelectedInstitution = a}} onDelete={a=>{control.load()}} />
                                ))
                            }
                            </div>
                            <div className='d-flex pt-2'>
                                <input type="text" className='w-100 input-field' onKeyDown={handleKeyDown} value={control.NewElement} onChange={a=>control.NewElement = (a.target.value)} />
                                <div className='px-3'></div>
                                <div ref={addingButton} className={`material-symbols-outlined success-item c-pointer m-auto fs-3 px-2`} onClick={()=>{ control.addInistitution()} } > add  </div>
                            </div>
                        </Col>
                        <Col xl={4} className=' p-1 pt-4 px-md-3 h-100'>
                            <div className='border p-1 h-100' style={{display:'grid' , gridTemplateRows:'1fr auto'}}>
                                <div className=' overflow-y-auto'>
                                {
                                    control.Data?.data.find(a=>a.id===control.SelectedInstitution)?.courses.map((item,index)=>(
                                        <div key={index} className='d-flex justify-content-between py-3 px-1'
                                            style={{background:index%2?'rgba(250,250,250,0.5)':'rgba(240,240,240,1)'}}    >
                                            <div>{item.course}</div>
                                            <div>
                                                <button className='button-II btn-cl-I ' onClick={()=>{control.detachCourseFromInstitution(item.id)}}>ازالة</button>
                                            </div>
                                        </div>
                                    ))
                                }
                                </div>
                                <div className='d-flex'>
                                    <CustomSelect list={control.Data?.courses?.filter(i=>!control.Data?.data.find(a=>a.id===control.SelectedInstitution)?.courses.some(ii=>ii.id==i.id))?.map(a=>({label:a.course , value:a.id}))||[]} selected={control.CourseToAttach} onSelect={(a)=>control.CourseToAttach=a} ></CustomSelect>
                                    <div className={`material-symbols-outlined success-item c-pointer m-auto fs-3 px-2`} onClick={()=>{ control.attachCourse() } } > add  </div>

                                </div>
                            </div>
                        </Col>
                        <Col xl={4} className=' p-1 pt-4 px-md-3 h-100'>
                            <div className='border p-1 h-100' style={{display:'grid' , gridTemplateRows:'1fr auto'}}>
                                <div className=' overflow-y-auto'>
                                {
                                    control.Data?.data.find(a=>a.id===control.SelectedInstitution)?.level_specializations.map((item,index)=>(
                                        <div key={index} className='d-flex justify-content-between py-3 px-1'
                                            style={{background:index%2?'rgba(250,250,250,0.5)':'rgba(240,240,240,1)'}}    >
                                            <div>{item.level_specialization}</div>
                                            <div>
                                                <button className='button-II btn-cl-I ' onClick={()=>{control.detachLevelSpecializationFromInstitution(item.id)}}>ازالة</button>
                                            </div>
                                        </div>
                                    ))
                                }
                                </div>
                                <div className='d-flex'>
                                    <CustomSelect list={control.Data?.level_specializations?.filter(i=>!control.Data?.data.find(a=>a.id===control.SelectedInstitution)?.level_specializations.some(ii=>ii.id==i.id))?.map(a=>({label:a.level_specialization , value:a.id}))||[]} selected={control.LevelSpecializationToAttach} onSelect={(a)=>control.LevelSpecializationToAttach=a} ></CustomSelect>
                                    <div className={`material-symbols-outlined success-item c-pointer m-auto fs-3 px-2`} onClick={()=>{ control.attachLevelSpecialization() } } > add  </div>
                                </div>
                            </div>
                        </Col>
                    </Row>)
                }
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
      )
}

export default InstitutionsList
